import { Card, CardContent, CardTitle, CardHeader } from "@dxp-feed/ui/Card";
import { Box } from "@dxp-feed/ui/Box";
import ImageWrapper from "@/components/ImageWrapper";
import { SiteContainer } from "@/components/Container";
import { AemHost } from "@/utils/constant";
import { RenderHTML } from "@/helpers/ServerFuncytions";

const BakeryCards = ({ props }: any) => {
  return (
    <Box as="div" className="lg:mt-2">
      <SiteContainer className="w-full mx-auto">
        <Box className="grid gap-6 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3">
          {props?.multicards.map((card: any, index: number) => (
            <Card
              key={index + "ww"}
              className="!rounded-xl h-full border border-neutral100 shadow-md flex flex-col justify-start items-stretch"
            >
              <CardHeader className="!p-0 !border-[0px] ">
                <Box as="div">
                  <ImageWrapper
                    src={AemHost + card?.image}
                    className="mx-auto w-full md:h-auto  h-[242px] object-cover"
                    alt={card?.imagealt ? card?.imagealt : card?.heading}
                    width={464}
                    height={218}
                    tabIndex={0}
                  />
                </Box>
              </CardHeader>

              <Box
                as="div"
                className="p-[16px] lg:p-[24px] flex flex-col justify-between items-start h-full"
              >
                <CardContent className="!p-0">
                  <CardTitle className="text-brandBlack text-xl  mb-2 lgs:mb-4 font-raleway font-normal">
                    {card?.heading}
                  </CardTitle>
                  <Box
                    as="div"
                  >{RenderHTML(card?.description)}</Box>
                </CardContent>
              </Box>
            </Card>
          ))}
        </Box>
      </SiteContainer>
    </Box>
  );
};

export default BakeryCards;
